import { render, staticRenderFns } from "./ServiceProviderList.vue?vue&type=template&id=64105940&scoped=true"
import script from "./ServiceProviderList.vue?vue&type=script&lang=js"
export * from "./ServiceProviderList.vue?vue&type=script&lang=js"
import style0 from "./ServiceProviderList.vue?vue&type=style&index=0&id=64105940&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64105940",
  null
  
)

export default component.exports